import { type FC } from 'react';
import { usePageMeta } from '@/hooks/usePageMeta';
import type { PageMeta } from '@/config/meta';

interface MetaUpdaterProps {
  /**
   * Optional custom meta to override base route meta
   * Can be a static object or a function that returns meta based on route params
   */
  customMeta?: Partial<PageMeta> | (() => Partial<PageMeta>);
  /**
   * Optional function to generate dynamic title based on route parameters
   * Useful for pages with dynamic routes like /data-import/:step
   */
  dynamicTitleFn?: (params: Record<string, string | undefined>) => string;
}

/**
 * Component that automatically updates page meta (title, description, etc.) based on current route
 * This component should be placed once in the app root (typically in App.tsx)
 * It listens to route changes and updates document title and meta tags accordingly
 */
export const MetaUpdater: FC<MetaUpdaterProps> = ({ customMeta, dynamicTitleFn }) => {
  usePageMeta(customMeta, dynamicTitleFn);
  return null; // This component doesn't render anything
};
